import { BaseModal } from 'src/components/AriaModal';
import { InsightsFilterSet } from '../../routes/InsightsCompare/types';
import {
  InsightsAdvancedFilterForm,
  InsightsAdvancedFilters,
} from '../InsightsAdvancedFilterForm';

export const InsightsAdvancedFilterModal: React.FC<{
  show: boolean;
  platform: 'facebook' | 'tiktok';
  filterSet: InsightsFilterSet | null;
  onComplete: (filterSet: InsightsFilterSet) => void;
  onClose: () => void;
  customEvents: string[];
  customConversions: Array<{ facebookId: string; name: string }>;
}> = ({ show, onClose, filterSet, ...rest }) => {
  return (
    <BaseModal
      show={show}
      onClose={onClose}
      className="rounded-xl bg-white"
      modalClassName="w-[800px] min-w-52 bg-white rounded-xl overflow-auto max-h-[70vh]"
      aria-label="group filters modal"
    >
      <InsightsAdvancedFilterForm filterSet={filterSet}>
        <InsightsAdvancedFilters
          onClose={onClose}
          filterSet={filterSet}
          isAdvancedFilter
          {...rest}
        />
      </InsightsAdvancedFilterForm>
    </BaseModal>
  );
};
